<div class="more-options-container" [id]="uniqueId">
    <div [ngClass]="openDropdown ? 'dots-button-selected' : 'dots-button'" (click)="toggleDropdown()">
        <img src="../../../assets/icons/datatable-dots-horizontal.svg" alt="Dots Menu" />
    </div>
    <div class="more-options-dropdown" *ngIf="openDropdown" [style.top]="top" [style.right]="right"
        [style.width]="width ? width : ''">
        <div *ngFor="let menuOption of menuOptions; let last = last; let first = first" [ngClass]="menuOption?.Class">
            <div class="button-option"
                [ngClass]="{'first-option': first, 'last-option': last, 'has-restriction': menuOption.DisabledMessage}"
                (click)="$event.stopPropagation(); !menuOption.DisabledMessage ? optionEmit(menuOption.Id) : null">

                <div class="option-main-content">
                    <img *ngIf="menuOption.Icon" [src]="menuOption.Icon" />
                    <div class="text-container">
                        <span>{{menuOption.Text}}</span>
                        <div class="restriction-msg" *ngIf="menuOption.DisabledMessage">
                            {{ menuOption.DisabledMessage }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="split" *ngIf="!last"></div>
        </div>
    </div>
</div>